import React, { useState } from 'react';
import { Container } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import Button from '../../../components/Buttons/Button';
import DataTable from '../../../components/DataTable/DataTable';
import ButtonBar from '../../../components/Fields/ButtonBar';
import Form from '../../../components/Fields/Form';
import SelectListField from '../../../components/Fields/SelectListField';
import { FormConfig } from '../../../components/Fields/Types';
import useSelectListOptions from '../../../components/Hooks/SelectListOptionsHook/useSelectListOptions';
import useValidation from '../../../components/Hooks/ValidationHook/useValidation';
import { useAuth } from '../../../contexts/authContext';
import { useNotifications } from '../../../contexts/notificationContext';
import BrandModel from '../../../models/BrandModel';
import DataService from "../../../services/data.service";
import { Result } from '../../../types/Result';

interface IFormData {
    externalSystemId: number
}

const ExportBrands: React.FC = () => {
    const [formData, setFormData] = useState<IFormData>({ externalSystemId: 0 })
    const [data, setData] = useState<BrandModel[]>();
    const { handleResult, handleException } = useNotifications();

    const externalSystems = useSelectListOptions('api/v1/selectlist/ExternalSystems', '-- Select external system');

    function getTableData() {
        DataService.get<BrandModel[]>(`api/v1/brands/notReadyForExport/${formData.externalSystemId}`)
            .then(response => {
                setData(response);
            })
            .catch(e => { handleException(e); });
    }

    function exportBrands() {
        if (data) {
            const selectedBrands = {
                externalSystemId: formData.externalSystemId,
                brands: data.filter((r) => r['_checkbox_export'] == true)
            }

            DataService.post<Result>(`api/v1/brands/export/`, selectedBrands)
                .then(response => {
                    handleResult(response)
                    getTableData()
                })
                .catch(e => { handleException(e); });
        }
    }

    function selectAllRows(selectedRows: any[]) {
        if (data) {
            if (selectedRows.length != data.length)
                data.forEach(r => r['_checkbox_export'] = true)
            else
                data.forEach(r => r['_checkbox_export'] = false)

            setData(x => ({ ...data }))
        }
    }

    const formConfig: FormConfig = {
        fields: [{ name: 'externalSystemId', label: 'External system' }],
        handleFieldChanged: getTableData,
        handleSubmit: getTableData,
        showErrors: 'always',
    };

    const { getFieldProps } = useValidation(formConfig, formData);

    return (
        <>
            <div className='main-content'>
                <Form title='Export brands' footer={(
                    <ButtonBar offset={2}>
                        <Button text='Export' type='button' onClick={exportBrands} />
                    </ButtonBar>
                )}>
                    <Container fluid>
                        <SelectListField {...getFieldProps('externalSystemId')} options={externalSystems} />
                    </Container>
                </Form>
                <div className="card" style={{ margin: '0 12px', padding: 12 }}>
                    <DataTable
                        name='dtBrands'
                        tableData={data}
                        colInfos={[
                            { checkboxButton: { icon: 'fa-check', color: 'green', text: 'export', /*onClick: (selectedRows) => { selectAllRows(selectedRows); }*/ } },
                            { title: 'ID', key: true, dataProp: 'id', dataType: 'number' },
                            { dataProp: 'thumbnailUrl', dataType: 'image' },
                            { title: 'Name', dataProp: 'name', sort: 'asc', filterInfo: { filterType: 'Textbox' } },
                            { title: 'Abbr.', dataProp: 'abbreviation', filterInfo: { filterType: 'Textbox' } },
                            { title: 'Level', dataProp: 'treeLevel', filterInfo: { filterType: 'CheckboxList' } },
                            { title: 'Tree', dataProp: 'nameTree', filterInfo: { filterType: 'Textbox' } },
                        ]}
                    />
                </div>
            </div>
        </>
    );
}
export default ExportBrands;